// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const urshifu_single_strike: PokeData = {
  "id": 892,
  "name": "urshifu-single-strike",
  "height": 19,
  "weight": 1050,
  "base_experience": 275,
  "types": [
    PokeType.FIGHTING,
    PokeType.DARK
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "counter",
    "focus-energy",
    "scary-face",
    "detect",
    "endure",
    "dynamic-punch",
    "rock-smash",
    "focus-punch",
    "brick-break",
    "aerial-ace",
    "bulk-up",
    "close-combat",
    "sucker-punch",
    "iron-head",
    "wicked-blow"
  ],
  "moves": [
    "headbutt",
    "leer",
    "scary-face",
    "rock-smash",
    "aerial-ace",
    "bulk-up",
    "close-combat",
    "lash-out",
    "superpower",
    "snatch",
    "vacuum-wave",
    "dark-pulse",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 470,
    "item": null,
    "species": [
      {
        "name": "kubfu",
        "order": 891,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "urshifu",
        "order": 892,
        "types": [
          PokeType.FIGHTING,
          PokeType.DARK
        ],
        "evolves_from_species_id": 891,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TOWER_OF_DARKNESS
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TOWER_OF_WATERS
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 122,
    "ability_power": 164
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
